import { render, staticRenderFns } from "./ActionPlansTable.vue?vue&type=template&id=67187b48&scoped=true"
import script from "./ActionPlansTable.vue?vue&type=script&lang=js"
export * from "./ActionPlansTable.vue?vue&type=script&lang=js"
import style0 from "./ActionPlansTable.vue?vue&type=style&index=0&id=67187b48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67187b48",
  null
  
)

export default component.exports